import { setAlpha, ThemeTypes, Z_INDEX } from '@talos/kyoko';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const CutoutOverlayWrapper = styled(motion.div)`
  position: fixed;
  inset: 0;
  z-index: ${Z_INDEX.modal - 2};
  pointer-events: none;
`;

export const ContrastLayer = styled(motion.div)`
  position: fixed;
  z-index: ${Z_INDEX.modal - 3};
  pointer-events: none;
  backdrop-filter: ${({ theme }) =>
    theme.type === ThemeTypes.dark ? 'contrast(1.05) brightness(1.5)' : 'saturate(1.5)'};
  box-shadow: 0 0 25px ${({ theme }) => setAlpha(0.05, theme.colors.gray['100'])} inset;
`;

export const ShowcaseTitle = styled.h4`
  margin: ${({ theme }) => `${theme.spacing8}px 0 ${theme.spacing4}px 0`};
  font-size: ${({ theme }) => theme.fontSizeTitleH4}rem;
  line-height: ${({ theme }) => theme.lineHeightTitleH4}rem;
  font-weight: ${({ theme }) => theme.fontWeightMedium};
  color: ${({ theme }) => theme.colorTextImportant};
`;

export const ShowcaseImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: ${({ theme }) => theme.borderRadiusLarge}px;
  margin-bottom: ${({ theme }) => theme.spacing12}px;
  border: solid 2px ${({ theme }) => theme.colors.gray['000']};
`;

export const ShowcaseDescription = styled.div`
  font-size: ${({ theme }) => theme.fontSizeDefault}rem;
  color: ${({ theme }) => theme.colorTextDefault};
  line-height: 1.5;
  flex: 1;

  /* Formatting for the description text */
  p {
    margin: 0 0 ${({ theme }) => theme.spacing12}px 0;
  }

  p:last-child {
    margin-bottom: 0;
  }

  ul {
    background-color: ${({ theme }) => theme.backgroundContent};
    padding: ${({ theme }) => theme.spacing16}px;
    padding-left: ${({ theme }) => theme.spacing32}px;
  }

  li::marker {
    color: ${({ theme }) => theme.colors.green.lighten};
  }

  a {
    color: ${({ theme }) => theme.colors.blue.lighten};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StepIndicator = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing4}px;
`;

export const StepDot = styled.button<{ active?: boolean; visited?: boolean }>`
  width: 8px;
  height: 8px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${({ theme, active, visited }) =>
    active ? theme.colors.gray['100'] : visited ? theme.colors.gray['070'] : theme.colors.gray['050']};
  cursor: pointer;
  transition: background 150ms ease;

  &:hover {
    background: ${({ theme, active }) => (active ? theme.colors.gray['100'] : theme.colors.gray['060'])};
  }
`;
